import {Observable, ReplaySubject} from 'rxjs';
import {Response} from '@angular/http';
import {Model} from './model.class';
import {Service} from './service.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class ModelListService<T extends Model<T>> {

    private _service: Service;

    private _changesSubject$ = new ReplaySubject<boolean>(1);
    changes$: Observable<boolean> = this._changesSubject$;

    constructor(svcm: Service.InjectedMembers, namespace: string, protected readonly _modelType: Model.Type<T>, private readonly _basePath: string) {
        this._service = new Service(svcm, namespace);
    }

    getModelEntries(projection?: ProjectionInformation): Observable<Array<T>> {
        return this._service.getList<T>(this._modelType, this._basePath, projection);
    }

    getModelEntryIdsSortedByIndex(): Observable<Array<string>> {
        return this._service.call('currentUser/indexes').map(res => res.json());
    }

    doesModelEntryExist(index: number): Observable<boolean> {
        return this._service.exists<T>(this._modelType, this._pathFor(index));
    }

    getModelEntry(index: number, projection?: ProjectionInformation): Observable<T | undefined> {
        return this._service.get<T>(this._modelType, this._pathFor(index), projection);
    }

    updateModelEntry(index: number, model: T): Observable<Response> {
        return this._service.update(model, this._pathFor(index)).do(() => this._changesSubject$.next(true));
    }

    countModelEntries(): Observable<number> {
        return this._service.count<T>(this._modelType, this._basePath);
    }

    private _pathFor(index: number) { return `${this._basePath}/${index}`; }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/model-list.service.ts